import Create from './create/CreateDigitalDistributionSectionTemplate';
import Edit from './edit/EditDigitalDistributionSectionTemplate';
import Individual from './individual/DigitalDistributionTemplateSection';

export default { Create, Individual, Edit };
